export default (() => {

    const lsn = "pxn.whatInput.lastInputType";

    const keysBlacklist = [
        16, // shift
        17, // control
        18, // alt
        91, // Windows key / left Apple cmd
        93, // Windows menu / right Apple cmd
        27, // escape,
        116 // f5
    ];

    const inputClasses = ['is-keyboard', 'is-mouse', 'is-touch'];


    // Init what-input

    whatInput.ignoreKeys(keysBlacklist);
    whatInput.registerOnChange(setInputClass, 'intent');


    // Initial body class

    setInputClass(getLastInputType());


    // Remember last input type

    addEventListener('beforeunload', () => {
        localStorage.setItem(lsn, whatInput.ask('intent'));
    });


    // Helpers

    function prefixClass(className) {
        return `is-${className}`;
    }

    function getLastInputType() {
        return localStorage.getItem(lsn) || whatInput.ask('intent');
    }

    function setInputClass(type) {
        var inputClass = prefixClass(type);
        inputClasses.map((c) => { if (c !== inputClass) document.body.classList.remove(c) });

        document.body.classList.add(inputClass);
    }


})();
